import { render, staticRenderFns } from "./ProgramaRecompensa.vue?vue&type=template&id=27448362&"
import script from "./ProgramaRecompensa.vue?vue&type=script&lang=js&"
export * from "./ProgramaRecompensa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports